import {Component, computed, inject, input, signal} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TranslocoService} from '@jsverse/transloco';
import {LucideAngularModule, MessageSquareLockIcon, ShieldCheckIcon} from 'lucide-angular';
import {HostDTO} from '@domain/host/host.dto';

@Component({
  selector: 'app-host-contact-privacy-note',
  providers: [],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    LucideAngularModule
  ],
  templateUrl: './host-contact-privacy-note.component.html'
})
export class HostContactPrivacyNote {

  public readonly showLearnMore = signal(false);

  public readonly host = input.required<HostDTO>();
  public readonly hostName = computed(() => this.host().name ?? '');


  public readonly icons = {
    shield: ShieldCheckIcon,
  };

  public toggleShowLearnMore(): void {
    this.showLearnMore.set(!this.showLearnMore());
  }

}
